import {
    Card, CardHeader, CardContent, Box, Chip, FormControl, FormHelperText, IconButton, MenuItem, Select, SelectChangeEvent, Typography,
    Button, TableCell, Unstable_Grid2 as Grid, TextField, Checkbox, ListItemText, FormControlLabel, InputLabel, ToggleButton, ToggleButtonGroup, Avatar, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle,
    Divider
} from "@mui/material";
import { Add, Close } from '@mui/icons-material';
import { DataField, DropdownModel, FilterAttribute, FormDataOutput } from "../../data/interfaces/sharedmodels";
import { useAppSelector, useAppDispatch } from "../../stores/hooks";
import {
    updateFilterAtts as updateMagneticFilterAtts
} from "../../stores/magneticslice";
import { useCallback, useContext, useEffect, useState } from "react";
import magneticService from "../../data/api/magnetic.service";
import { showerrormessage, showsuccessmessage, showwarningmessage } from "../../stores/notificationslice";
import ConfirmDialog from "../confirmdialog";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider, TimePicker, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MasterListDialog from "../../modules/masterlist/childcomponents/masterlistdialog";
import DataTableHeader from "../childcomponents/datatableheader";
import { formatValueAsReadOnly, formatValue, formatValueForApi } from "../commonfunctions";
import { MenuProps } from "../commonprops";
import ButtonFieldPopup from "./buttonfieldpopup";
import { IsEditedContext } from "../../../App";




const EditableField = ({ errorFields, field, value, fieldLookups, fieldgroup, callback, isEditable }:
    {
        errorFields: string[], field: DataField, value: any, fieldLookups: DropdownModel[] | undefined,
        fieldgroup: string, callback: any, isEditable: boolean
    }) => {
    const [currentValue, setCurrentValue] = useState(value);
  
    const [isLoaded, setIsLOaded] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false); 
    const [tempModifiedData, setTempModifiedData] = useState<any>(null);

    const handleButtonClick = () => {
        setDialogOpen(true); 
    };

  

    const accumulateTempData = useCallback((tableId: string, modifiedData: any) => {
        setDialogOpen(false);    
        setTempModifiedData(modifiedData);
        callback(field,fieldgroup,modifiedData);
    },[value])
    
    

    const dispatch = useAppDispatch();
    useEffect(() => {
        setCurrentValue(value);
      
        setIsLOaded(true);
        if(value == null){
            setTempModifiedData(null);
        }
    }, [value])

    useEffect(() => {
        if (isLoaded && currentValue != value)
            callback(field, fieldgroup, currentValue);
    }, [currentValue])
    const handleChange = (event: any) => {
        
        
        if (field.Type === "checkbox") {
            setCurrentValue(event.target.checked);
        }
        else {
            if (field.IsMultiSelect && field.Max != null) {
                if (event.target.value && event.target.value.length <= field.Max)
                    setCurrentValue(event.target.value);
                else
                    dispatch(showwarningmessage("You can select only a maximum of " + field.Max + " " + field.Description));
            }
            else
                setCurrentValue(event.target.value);
             
        }
    }

    const handleTimeHourNMinutesChange = (val: any, ishour: boolean) => {
       
        let curValue = formatValue(currentValue, field.Type);
        let hourVal = curValue < 60 ? 0 : Math.floor(curValue / 60);
        let minValue = curValue < 60 ? curValue : curValue - Math.floor(curValue / 60) * 60;
        if (ishour) {
            setCurrentValue((val * 60) + minValue);
        }
        else {
            setCurrentValue(val + (hourVal * 60));
        }
    }

    const handleBoolChange = (event: any) => {
       
        setCurrentValue(event.target.checked);
    }
    const handleDateChange = (value: Dayjs) => {
       
        if (field.CustomFormat == "Time24") {
            let startHour = dayjs().startOf('day')
            setCurrentValue(value.diff(startHour, 'minute', false));
        }
        else {
            setCurrentValue(value.toDate());
        }


    }
    if (field.ButtonField != null){
            
        return (
            <>
            <Button sx={{ width: '100%' }} variant="outlined" onClick={handleButtonClick}>
                {field.Description}
            </Button>
           
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md">
                <DialogTitle     sx={{
borderBottom: '1px solid #e0e0e0',
paddingBottom: '16px',
marginBottom: '16px',
display: 'flex',
justifyContent: 'space-between'
}} fontSize={28}>{field.Description}   <IconButton onClick={() => setDialogOpen(false)}>
<Close />
</IconButton></DialogTitle>
             
                <DialogContent>
                   <ButtonFieldPopup  value={tempModifiedData} parent='itso' heading={field.Description} tableid={field.ButtonField}  callbackaccumulateTempData={accumulateTempData} ></ButtonFieldPopup>
                </DialogContent>
              
            </Dialog>
        </>
        )

    }
    else if ((isEditable && field.IsEditable) || field.IsFilterField) {
        if (fieldLookups) {
            if (field.IsMultiSelect) {
                return (
                    <FormControl fullWidth>
                        <InputLabel className="custom-multi-input-lable">{field.Description}</InputLabel>
                        <Select
                            size="small"

                            label={field.Description}
                            multiple
                            sx={{ width: '100%'}}
                            value={currentValue || [-99]}
                            renderValue={(selected) => fieldLookups.filter(a => selected.findIndex((d: string) => d == a.Id) > -1).flatMap(d => d.Description).join(', ')}
                            onChange={handleChange}
                            MenuProps={MenuProps}>
                            {
                                fieldLookups.map((item) => {
                                    return (
                                        <MenuItem key={item.Id} value={item.Id}>
                                            <Checkbox checked={currentValue.indexOf(item.Id) > -1} />
                                            <ListItemText primary={item.Description} />
                                        </MenuItem>
                                    )
                                })}


                        </Select>
                    </FormControl>
                )
            }
            else {
                return (
                    <FormControl fullWidth >
                        <InputLabel>{field.Description}</InputLabel>
                        <Select
                            size="small"
                            label={field.Description}
                            sx={{ width: '100%' }}
                            value={currentValue != null ? currentValue.toString()  : "-99"}
                            onChange={handleChange}>

                            {
                                fieldLookups.map((item) => {
                                    return (
                                        <MenuItem key={item.Id} value={item.Id}>{field.LookUpShowIdDesc ? item.Id + " - " + item.Description : item.Description}</MenuItem>
                                    )
                                })}


                        </Select>
                    </FormControl>
                )
            }
        }
        else if (field.CustomFormat && field.CustomFormat === "Time24") {
            return (
                <div className="datepickerclass">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker 
                        maxTime={dayjs().startOf('day').set('minute',  (field.Max!=null?(field.Max-(60*24)):5))}
                         label={field.Description} ampm={false} sx={{ width: '100%' }} onChange={(value) => handleDateChange(value)} defaultValue={formatValue(currentValue, field.Type, field.CustomFormat)} />
                    </LocalizationProvider>
                </div>
            )

        }
        else if (field.CustomFormat && field.CustomFormat === "HoursNMinutes") {
            let formatedValue = formatValue(currentValue, field.Type);
            let hours = [...Array(23 - 0 + 1).keys()].map((i) => i + 0);
            let minutes = [...Array(Math.floor(59 / 5) + 1).keys()].map((i) => i * 5);
            return (
                <Box sx={{ width: '100%', minWidth: 500 }}>
                    {field.Description}
                    <Box component='div' sx={{ display: 'flex', mt: 2 }}>

                        <FormControl fullWidth>
                            <InputLabel>Hours</InputLabel>
                            <Select
                                size="small"
                                label="Hours"
                                id="hour"
                                sx={{ width: '100%', minWidth: 100 }}
                                value={formatedValue < 60 ? 0 : Math.floor(formatedValue / 60)}
                                onChange={(event) => handleTimeHourNMinutesChange(event.target.value, true)}>

                                {
                                    hours.map((item) => {
                                        return (
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        )
                                    })}


                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel>Minutes</InputLabel>
                            <Select
                                size="small"
                                label="Minutes"
                                id="minute"
                                sx={{ width: '100%', minWidth: 100, ml: 1 }}
                                value={formatedValue < 60 ? formatedValue : formatedValue - Math.floor(formatedValue / 60) * 60}
                                onChange={(event) => handleTimeHourNMinutesChange(event.target.value, false)}>

                                {
                                    minutes.map((item) => {
                                        return (
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        )
                                    })}


                            </Select>
                        </FormControl>
                    </Box>
                </Box>
            )
        }
        else if (field.Type === 'date') {
            return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker sx={{ width: '100%' }} onChange={(value) => handleDateChange(value)} value={formatValue(currentValue, field.Type)} format="MMM D, YYYY" />
                </LocalizationProvider>

            )
        }
        else if (field.Type === 'checkbox') {
            return (
                <FormControlLabel sx={{ width: '100%' }} control={<Checkbox size="small" onChange={handleBoolChange} checked={currentValue} value={formatValue(currentValue, field.Type)} />} label={field.Description} />



            )
        }
        else if (field.Type === 'number') {
            return (
                <TextField label={field.Description} size="small" sx={{ width: '100%' }} onChange={handleChange} value={formatValue(currentValue, field.Type)??''} type={field.Type}
                    error={errorFields.includes(field.Name)}
                    helperText={field.Type == 'number' ? (errorFields.includes(field.Name) ? 'Please enter a number between ' + field.Min?.toString() + ' and ' + field.Max?.toString() : '') : ''}
                    InputProps={{
                        inputProps: {
                            min: field.Min,
                            max: field.Max,
                            step: 1
                        },
                    }} />

            )
        }
        else {
            return (
                <TextField label={field.Description} size="small" sx={{ width: '100%' }} onChange={handleChange} value={formatValue(currentValue, field.Type)} type={field.Type}
                    error={errorFields.includes(field.Name)}
                    helperText={field.Type == 'text' ? (errorFields.includes(field.Name) ? 'Please enter upto ' + field.Max?.toString() + ' characters' : '') : ''}
                    InputProps={{
                        inputProps: {
                            min: field.Min,
                            max: field.Max,
                            step: 1
                        },
                    }} />

            )
        }
    }
    else {
        return (
            <Box >
                <Typography >{field.Description}:</Typography>
                <Typography sx={{ fontWeight: 600 }}>{currentValue && fieldLookups ?
                    fieldLookups.find(f => f.Id.toString() == currentValue)?.Description :
                    formatValueAsReadOnly(currentValue, field.Type, field.CustomFormat, field.IsMultiSelect)}</Typography>
            </Box>
        )
    }



}

const EditableFormFields = ({ data, parent, callback }: { data: FormDataOutput, parent: string, callback: any }) => {
    
    const dispatch = useAppDispatch();
   
    const [currentData, setCurrentData] = useState<FormDataOutput>(data);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const [isMasterListOpen, setIsMasterListOpen] = useState<boolean>(false);
    const [selectedMasterList, setSelectedMasterList] = useState<DropdownModel>({ Id: '0', Description: '' });
    const [currentMasterListCodes, setCurrentMasterListCodes] = useState<string[]>([]);
    const [errorFields, setErrorFields] = useState<string[]>([]);
    const [tempLookupValues, setTempLookupValues] = useState<DropdownModel[]>([]);
    const { setIsEdited } = useContext(IsEditedContext) ;
   
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const editorType = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.editorType; }
        else { return state.itsoReducer.editorType; }
    });

    // useEffect(() => {
    //     setCurrentData(data);
    //     setErrorFields([]);
    // }, [data]);

    useEffect(() => {
      
        if (tempLookupValues.length > 0) {
            let updatedData = { ...data };
            let field = currentData.Fields.filter(a => selectedMasterList != null && a.MasterList?.Id === selectedMasterList.Id)[0];
            let fieldLookup = currentData.FieldLookups.filter(a => a.FieldName === field.Name)[0];
            
          
            let newLookupValues = tempLookupValues.filter(
                (item) => !fieldLookup.LookUpValues.some(existingItem => existingItem.Id === item.Id)
            );
            
           
            newLookupValues = fieldLookup.LookUpValues.concat(newLookupValues);
            
            
            updatedData.FieldLookups.filter(a => a.FieldName === field.Name)[0].LookUpValues = newLookupValues;
          
            setCurrentData(updatedData);
        
            
          
           
        } else {
          
            setCurrentData(data);
         
        }
        setErrorFields([]);
    }, [data, tempLookupValues]);

    const handleValueChange = useCallback((field: DataField, formGroup: string, newValue: any) => {
        
        setIsEdited(true);
        if (field.IsFilterField) {
            let filterFields: FilterAttribute[] = [{ Name: field.Name, Value: newValue, DataType: field.DataType }];
            currentData.Fields.filter(a => a.IsFilterField && a.Name != field.Name).forEach(field1 => {
                let val = currentData.FieldGroups.filter(a => a.Description == field1.FieldGroup)[0].Attributes.filter(a => a.Name == field1.Name)[0].Value;
                filterFields.push({ Name: field1.Name, Value: val, DataType: field1.DataType })
            });

          
            
            dispatch(updateMagneticFilterAtts(filterFields));
       
            
        }
        else {
            let newData = { ...currentData };
            newData.FieldGroups.filter(a => a.Description == formGroup)[0].Attributes.filter(b => b.Name == field.Name)[0].Value = newValue;
            setCurrentData(newData);
        }


    }, [currentData])



    const isValid = (data: any) => {
        let tempErrorfields: string[] = [];
        for (const field of data.Fields) {
            debugger;
            const value = data.FieldGroups.flatMap((group: { Attributes: any; }) => group.Attributes)
                .find((attribute: { Name: any; }) => attribute.Name === field.Name).Value;
            if (field.ToggleField && currentData.FieldGroups.filter(f => f.Description == field.FieldGroup)[0]
                .Attributes.filter(a => a.Name == field.ToggleField)[0].Value == field.ToggleCondition)
                continue;
            else if (field.Type === "number") {
                if ((field.Min !== null && value < field.Min) || (field.Max !== null && value > field.Max)) {
                    if (!tempErrorfields.includes(field.Name)) tempErrorfields.push(field.Name);
                }

            }
            else if (field.Type == "text") {
                if ((field.Min !== null && value.length < field.Min) || (field.Max !== null && value.length > field.Max)) {
                    if (!tempErrorfields.includes(field.Name)) tempErrorfields.push(field.Name);
                }

            }
        }
        setErrorFields(tempErrorfields);
        return tempErrorfields.length < 1 ? true : false;
    }

    const handleSaveClick = () => {
        debugger;
        let modifiedData = { ...currentData }
        if (isValid(modifiedData)) {
            modifiedData.Version = selectedVersion ?? "";
            const updateInput = { NlcId: selectedNlcs.length > 0 ? selectedNlcs[0].Id : 0, TocId: 1, InputData: modifiedData };
            magneticService.updateFormData(updateInput).then((response) => {
                if (response && response.data) {
                    dispatch(showsuccessmessage("The data is saved successfully."))
                    setIsEdited(false);
                    callback();
                }
            });
        }
    }

    const handleSetCurrent = () => {
        setDialogTitle('Set Version');
        setDialogMessage('Confirm change of current version to as ' + selectedVersion + '?');

        setDialogOpen(true);
    }

    const setCurrentVersion = useCallback((confirmed: boolean, remarks: string) => {
        setDialogOpen(false);
        if (confirmed) {
           
                magneticService.setCurrentVersion(selectedVersion ?? "", selectedTable?.Id ?? 0, remarks, selectedNlcs.length ? selectedNlcs[0].Id : null).then((response) => {
                    if (response.data.IsSuccess) {
                        dispatch(showsuccessmessage(response.data.Message));
                        callback();
                    }
                    else {
                        dispatch(showerrormessage(response.data.Message))
                    }
    
                });
            
           
        }
    }, [selectedTable, selectedVersion])

    const showMasterList = (masterList: DropdownModel | null) => {
        if (masterList != null) {
            let field = currentData.Fields.filter(a => a.MasterList != null && a.MasterList.Id == masterList.Id)[0];
            let excludedCodes: string[] = [];
            currentData.FieldLookups.filter(a => a.FieldName == field.Name)[0].LookUpValues.forEach((item) => {
                excludedCodes.push(item.Id)

            })
            setCurrentMasterListCodes(excludedCodes);
            setSelectedMasterList(masterList);
            setIsMasterListOpen(true);
        }
    }

    const addNewMasterListItems = (items: DropdownModel[]) => {
      
        setIsMasterListOpen(false);
        if (items.length > 0) {
            let field = currentData.Fields.filter(a => selectedMasterList != null && a.MasterList?.Id === selectedMasterList.Id)[0];
            let fieldLookup = currentData.FieldLookups.filter(a => a.FieldName === field.Name)[0];
            let newLookupValues = items.filter(
                (item) => !fieldLookup.LookUpValues.some(existingItem => existingItem.Id === item.Id)
            );
            newLookupValues = fieldLookup.LookUpValues.concat(newLookupValues);
            let tempData = { ...currentData };
            tempData.FieldLookups.filter(a => a.FieldName === field.Name)[0].LookUpValues = newLookupValues;
            setCurrentData(tempData);
            setIsEdited(true);
            setTempLookupValues(items);
            
        }
    }


    
    return (
        <Box component='form'>

            {currentData.FieldGroups && currentData.FieldGroups.length > 0 ? currentData.FieldGroups.map((group, index) => {
                let skipFields = false;
                return (
                    <Card  key={group.Description}>
                        <CardHeader title={group.Description} sx={{ fontSize: 18 }} disableTypography />
                        <CardContent>
                            <Grid container spacing={2}>
                                {group.Attributes.filter(a => currentData.Fields.findIndex(b => b.Name == a.Name && b.IsBrowsable) > -1).sort((att1, att2) => {

                                    if ((currentData.Fields.filter(a => a.Name == att1.Name)[0].FieldGroupOrderNo ?? 0) >
                                        (currentData.Fields.filter(a => a.Name == att2.Name)[0].FieldGroupOrderNo ?? 0)) {
                                        return 1;
                                    }
                                    else if ((currentData.Fields.filter(a => a.Name == att2.Name)[0].FieldGroupOrderNo ?? 0) >
                                        (currentData.Fields.filter(a => a.Name == att1.Name)[0].FieldGroupOrderNo ?? 0)) {
                                        return -1;
                                    }
                                    return 0;
                                }).map((att, index2) => {
                                    let attField = currentData.Fields.filter(a => a.Name == att.Name)[0];
                                    if (attField.ToggleField && currentData.FieldGroups.filter(f => f.Description == attField.FieldGroup)[0]
                                        .Attributes.filter(a => a.Name == attField.ToggleField)[0].Value == attField.ToggleCondition)
                                        return;
                                    return (
                                        <Grid xs={attField.GridSizeOutof12 ?? 6} key={att.Name}>
                                            <Tooltip title={attField.ToolTip}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between',mb:1 }}>

                                                    <EditableField isEditable={currentData.IsEditable} errorFields={errorFields} field={attField} value={att.Value}
                                                        fieldgroup={group.Description} callback={handleValueChange}
                                                        fieldLookups={currentData.FieldLookups.findIndex(a => a.FieldName == att.Name) > -1 ?
                                                            currentData.FieldLookups[currentData.FieldLookups.findIndex(a => a.FieldName == att.Name)].LookUpValues : undefined} />
                                                    {currentData.IsEditable&& attField.MasterList != null ?
                                                        <Avatar sx={{ ml: 1, backgroundColor: 'primary.main' }}>
                                                            <IconButton color="secondary" onClick={() => showMasterList(attField.MasterList)}><Add />
                                                            </IconButton></Avatar> : null}

                                                </Box></Tooltip>
                                        </Grid>
                                    )

                                })}
                            </Grid>
                        </CardContent>
                        {index< currentData.FieldGroups.length-1? <Divider />:null}
                    </Card>
                )
            })

                : <Typography sx={{ m: 2 }} variant="h6">No data found for the current selection.</Typography>}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 2,mt:1 }}>
                
                {!currentData.ReadOnlyUser&& currentData.Version != selectedVersion ? <Button variant="outlined" onClick={handleSetCurrent}>Set Current Version</Button> : <div/>}
                {currentData.IsEditable ? <Button variant="contained" onClick={handleSaveClick}>{currentData.VersionDetails && currentData.VersionDetails.UniqueIdValue == null ? "Add" : "Save"}</Button> : null}


            </Box>
            <ConfirmDialog minCommentChar={10} needComments={true} isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={setCurrentVersion} />
            <MasterListDialog isopen={isMasterListOpen} listType={selectedMasterList}
                excludedCodes={currentMasterListCodes} callback={addNewMasterListItems} />
        </Box>
    )
}

export default function EditableForm({ heading, data, parent, versions, callback }:
    { heading: string | undefined, data: FormDataOutput, parent: string, versions: DropdownModel[], callback: any }) {

    return (
        <Card>
            <CardHeader title={<DataTableHeader heading={heading} parent={parent} versions={versions} />} />
            <CardContent>
                {heading == undefined ? '' : <EditableFormFields data={data} parent={parent} callback={callback} />}
            </CardContent>
        </Card>
    );
}